export default "__VITE_ASSET__2d47e379__"